var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFreePlan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_46_1099)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 18C1 20.2325 1.43972 22.4431 2.29405 24.5056C3.14838 26.5682 4.40059 28.4422 5.97918 30.0208C7.55778 31.5994 9.43185 32.8516 11.4944 33.706C13.5569 34.5603 15.7675 35 18 35C20.2325 35 22.4431 34.5603 24.5056 33.706C26.5682 32.8516 28.4422 31.5994 30.0208 30.0208C31.5994 28.4422 32.8516 26.5682 33.706 24.5056C34.5603 22.4431 35 20.2325 35 18C35 15.7675 34.5603 13.5569 33.706 11.4944C32.8516 9.43185 31.5994 7.55778 30.0208 5.97918C28.4422 4.40059 26.5682 3.14838 24.5056 2.29405C22.4431 1.43972 20.2325 1 18 1C15.7675 1 13.5569 1.43972 11.4944 2.29405C9.43185 3.14838 7.55778 4.40059 5.97918 5.97918C4.40059 7.55778 3.14838 9.43185 2.29405 11.4944C1.43972 13.5569 1 15.7675 1 18Z",
    stroke: "#1F1F1F",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5259 13.75C21.0612 12.8433 20.1886 12.2974 19.2592 12.3333H16.7395C15.3492 12.3333 14.2216 13.5988 14.2216 15.1666C14.2216 16.7287 15.3492 17.9981 16.7395 17.9981H19.2592C20.6495 17.9981 21.7771 19.2655 21.7771 20.8314C21.7771 22.3954 20.6495 23.6628 19.2592 23.6628H16.7395C15.8101 23.6987 14.9375 23.1528 14.4728 22.2462M17.9993 8.55551V12.3333M17.9993 23.6666V27.4444M6.66602 6.66663L9.49935 9.49996M26.4993 26.5L29.3327 29.3333",
    stroke: "#1F1F1F",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_46_1099"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreePlan);
export default __webpack_public_path__ + "static/media/free_plan.2618eb99e17b3e74b3152076374a6cd3.svg";
export { ForwardRef as ReactComponent };